<template>
	<v-dialog v-model="dialog" id="popup-dialog" width="420" persistent>
		<v-card :style="fontStyle">
			<v-card-title class="justify-center">
				<v-btn
					class="dialog__close"
					icon
					x-small
					@click.native="close()"
				>
					<v-icon>mdi-close</v-icon>
				</v-btn>

				<div class="popup-image-div text-center">
					<!-- CCEP green checkmark -->
					<v-icon
						v-if="
							$store.getters.pageId == 2695 ||
							$store.getters.pageId == 3194 ||
							$store.getters.pageId == 4414
						"
						color="success"
						size="130"
						>mdi-check-circle-outline</v-icon
					>

					<!-- Default message GIF -->
					<v-img
						v-else-if="sendType == 'email' || sendType == 'phone'"
						src="@/assets/images/message.gif"
					/>

					<div v-else-if="walletUrl" class="qr-frame mt-6 mb-2">
						<div class="label top px-2">
							{{ $t("after-submit.wallet-top") }}
						</div>
						<img
							class="qr-code ma-6"
							:src="`https://qrscan.codes/?url=${walletUrl}&size=6`"
							width="186"
						/>
						<div class="label bottom">
							<div class="inner px-2">
								{{ $t("after-submit.wallet-bottom") }}
							</div>
						</div>
					</div>
				</div>
			</v-card-title>

			<v-card-text class="text-center">
				<h2
					v-html="popup.title"
					class="mb-4"
					style="line-height: 2rem"
				></h2>

				<p class="mb-2" v-html="popup.text"></p>

				<div v-for="button in popup.buttons" :key="button.id">
					<a
						:href="redirectTarget(button.redirectTarget)"
						target="_self"
					>
						<button
							type="button"
							class="redirect__btn"
							:style="buttonStyle"
						>
							{{ button.redirectText }}
						</button>
					</a>
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import fontMixin from "@/mixins/fontMixin.js";

export default {
	name: "PopupDialog",
	events: ["close"],
	props: {
		popup: Object,
		sendType: String,
	},
	data() {
		return {
			dialog: false,
			walletUrl: null,
		};
	},
	mixins: [fontMixin],
	computed: {
		buttonStyle() {
			let borderRadius = 0;
			if (this.popup.btnRadius == "edged") {
				borderRadius = 5;
			} else if (this.popup.btnRadius == "rounded") {
				borderRadius = 25;
			}

			let width = "max-content";
			if (this.popup.btnSize == "half") {
				width = "50%";
			} else if (this.popup.btnSize == "full") {
				width = "100%";
			}

			return {
				color: this.popup.btnTextColor,
				backgroundColor: this.popup.btnColor,
				borderColor: this.popup.btnBorderColor,
				borderRadius: borderRadius + "px",
				width: width,
			};
		},
		qrFrameBottomStyle() {
			// Swedish text is large and will wrap so make font size smaller
			if (this.$i18n.locale === "se") {
				return { fontSize: "12px" };
			}

			return {};
		},
	},
	methods: {
		redirectTarget(targetUrl) {
			var matches = targetUrl.match(/\{(.*?)\}/g);

			if (matches == null) return targetUrl;

			for (let i = 0; i < matches.length; ++i) {
				let param = matches[i].slice(1, -1);
				param = this.getParameterByName(param);

				targetUrl = targetUrl.replace(matches[i], param);
			}

			return targetUrl;
		},
		getParameterByName(name, url = window.location.href) {
			//eslint-disable-next-line
			name = name.replace(/[\[\]]/g, "\\$&");
			var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
			var results = regex.exec(url);
			if (!results) return null;
			if (!results[2]) return "";
			return decodeURIComponent(results[2].replace(/\+/g, " "));
		},
		open() {
			this.dialog = true;
		},
		close() {
			this.dialog = false;
			this.$emit("close");
		},
		setWalletUrl(url) {
			this.walletUrl = url;
		},
	},
};
</script>

<style scoped>
.redirect__btn {
	display: inline-block;
	padding: 5px 15px 5px 15px;
	border: 1px solid;
	text-align: center;
	margin-top: 10px;
	font-size: 16px;
	height: 36px;
}

.popup-image-div {
	margin-bottom: 8px;
}

.qr-frame {
	position: relative;
	border: 6px solid black;
	border-radius: 10px;
	width: fit-content;
	margin: auto;
	line-height: 0;
}

.qr-frame .label {
	position: absolute;
	z-index: 1;
	line-height: 1;
	font-family: "Trebuchet MS", Helvetica, sans-serif !important;
	text-transform: uppercase;
	left: 50%;
	transform: translate(-50%, 0);
	text-align: center;
}

.qr-frame .label.top {
	top: -14px;
	background: white;
	font-size: 20px;
}

.qr-frame .label.bottom {
	bottom: -2px;
	height: 0;
}

.qr-frame .label.bottom .inner {
	background: white;
	font-size: 15px;
	width: max-content;
	max-width: 200px;
	transform: translate(0, -50%);
}

.qr-code {
	aspect-ratio: 1/1;
}
</style>
